import { Box, InputAdornment, TextField } from "@material-ui/core";
import { FC } from "react";
import { RegisterOptions, useController } from "react-hook-form";

const CustomTextField: FC<CustomTextFieldProps> = ({
  label,
  type = "text",
  multiline = false,
  minRows = 1,
  maxRows = 1,
  startAdornment = false,
  disabled = false,
  ...rest
}) => {
  const {
    field,
    fieldState: { invalid, isTouched, error },
  } = useController(rest);

  return (
    <Box my={1}>
      <TextField
        {...field}
        disabled={disabled}
        required={!!rest.rules.required}
        label={label}
        type={type}
        fullWidth
        multiline={multiline}
        minRows={minRows}
        maxRows={minRows}
        variant="outlined"
        size="small"
        error={isTouched && invalid}
        helperText={error?.message}
        InputProps={{
          startAdornment: startAdornment ? <InputAdornment position="start">+974</InputAdornment> : "",
        }}
      />
    </Box>
  );
};

interface CustomTextFieldProps {
  control: any;
  name: string;
  label: string;
  type?: "text" | "number" | "password";
  multiline?: boolean;
  minRows?: number;
  maxRows?: number;
  rules: RegisterOptions;
  defaultValue: string | number;
  startAdornment?: boolean;
  disabled?: boolean;
}

export default CustomTextField;
